// The stress mark and the arithmetic around it.
//
// A stressed spelling is the plain word with ONE combining acute (U+0301)
// inserted right after each stressed vowel. Nobody should ever type that
// character by hand: every screen that sets a stress does it by clicking a
// vowel, which is what these helpers serve.

export const ACUTE = '́';
export const stripAcutes = (s) => String(s).replace(/́/g, '');
const VOWELS = 'аеёиоуыэюя';
export const isVowel = (ch) => VOWELS.includes(String(ch).toLowerCase());

// Where the marks sit in a stressed spelling: offsets into the PLAIN word
// (how many characters come before each mark).
export function acuteOffsets(stressed) {
  const out = [];
  let plain = 0;
  for (const ch of String(stressed || '')) {
    if (ch === ACUTE) out.push(plain); else plain += 1;
  }
  return out;
}

// The plain word with marks at the given offsets.
export function buildStressed(word, offsets) {
  let s = String(word);
  const sorted = [...offsets].sort((a, b) => a - b);
  for (let k = sorted.length - 1; k >= 0; k -= 1) s = s.slice(0, sorted[k]) + ACUTE + s.slice(sorted[k]);
  return s;
}

// Put a mark on the i-th letter of `form`, or take it off if it is there.
// Several marks are legal — hyphenated names (Херцег-Нови) carry one per part.
export function toggleAcuteAt(stressed, form, i) {
  const offs = new Set(acuteOffsets(stressed));
  const off = i + 1;
  if (offs.has(off)) offs.delete(off); else offs.add(off);
  return offs.size ? buildStressed(form, [...offs]) : null;
}

// Carry the marks already placed over to a form still being typed, so adding
// the ending of a word does not throw its stress away. An offset that no
// longer fits the word is dropped.
export function reflowStress(stressed, nextForm) {
  if (!stressed) return null;
  const kept = acuteOffsets(stressed).filter((o) => o >= 1 && o <= nextForm.length);
  return kept.length ? buildStressed(nextForm, kept) : null;
}

// Two spellings of one word carry the same marks (case aside).
export const sameMarks = (a, b) => acuteOffsets(a || '').join() === acuteOffsets(b || '').join();
